import { UserExtension } from "@prisma/client";

import { USER_EXTENSIONS } from "enums/userExtensions";

class UserExtensionService {
  private readonly extensionsList: UserExtension[];

  constructor({ extensionsList }: { extensionsList: UserExtension[] }) {
    this.extensionsList = extensionsList;
  }

  isActive(extensionName: USER_EXTENSIONS) {
    const extension = this.extensionsList.find(
      (extension) => extension.extension === extensionName,
    );

    return extension?.isActive || false;
  }

  getConfig<T extends USER_EXTENSIONS>(
    extensionName: T,
  ): Extract<PrismaJson.UserExtensionConfig, { extension: T }> | null {
    const extension = this.extensionsList.find(
      (extension) => extension.extension === extensionName,
    );

    if (!extension) {
      return null;
    }

    return extension.config as Extract<
      PrismaJson.UserExtensionConfig,
      { extension: T }
    >;
  }
}

export default UserExtensionService;
